import React, { useEffect, useState } from 'react';
import { ChevronRight } from 'lucide-react';
import { trackAddToCart } from '../utils/metaPixel';
const CHECKOUT_URL = 'https://www.tubienestarinterno.com/cart/53266912084305:1';
export function StickyButton() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      const heroElement = document.getElementById('hero');
      if (heroElement) {
        const rect = heroElement.getBoundingClientRect();
        setIsVisible(rect.bottom < 0);
      } else {
        setIsVisible(window.scrollY > 500);
      }
    };
    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const goToCheckout = () => {
    trackAddToCart();
    window.location.href = CHECKOUT_URL;
  };
  if (!isVisible) return null;
  return <div className="fixed bottom-0 left-0 w-full z-50 md:hidden bg-white/95 backdrop-blur-sm border-t border-gray-200 shadow-[0_-2px_10px_rgba(0,0,0,0.05)] px-4 py-2 animate-fade-in-up" style={{
    animationDuration: '0.3s',
    paddingBottom: 'max(0.5rem, env(safe-area-inset-bottom))'
  }} data-id="element-116">
      <button onClick={goToCheckout} className="w-full bg-warm-accent text-white font-bold text-base py-3 rounded-full shadow-[0_4px_15px_rgba(246,173,85,0.4)] flex items-center justify-center gap-2 active:scale-[0.98] transition-transform" data-id="element-117">
        QUIERO MI DESCARGA (6,95€)
        <ChevronRight className="w-5 h-5" data-id="element-118" />
      </button>
    </div>;
}